import React from 'react'
import '../../App.css'
import './Contest.css'
import { SLide } from 'react-reveal/Slide'
import { FaCoffee } from 'react-icons/fa'
import { MdOutlineEmojiEvents} from 'react-icons/md'

import web from '../images/lacuna-ventur-startup-contest.png'
import { ContestItem } from './ContestItem'
import web2 from '../images/card1.jpg'
import web3 from '../images/card2.jpg'
import { Link } from 'react-router-dom'
import { Fade } from 'react-reveal'
export const Contest = () => {
  return (
    <>
      <section className="contest_wrapper">
        <div className="custom-shape-divider-bottom-1648805572">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" className="shape-fill"></path>
          </svg>
        </div>


        <div className="container">
          <div className="row">
            <div className="col-md-8 col-sm-12">
              <Fade>

              <div className="contest-text">
                <MdOutlineEmojiEvents color="white" size="5em" />
                <h1>Startup Contest</h1>
                <p className='pe-5'>Entrepreneurial challenges to promote and encourage entrepreneurs, startup founders build their entrepreneurial skills, leverage their skills as well learn from them through hands-on workshops, and win exciting prizes.</p>
              </div>
              </Fade>
            </div>
            <Fade right>

            <div className="col-md-4 col-sm-12">
              <div className="contest-img">
                <img src={web} alt="erb" className='img-fluid' />

              </div>
            </div>
            </Fade>
          </div>
        </div>
      </section>
      <div className="contest-card">
        <div className="container contest-tab">
          <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Currently Active</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Ended</button>
            </li>

          </ul>


        </div>



        <div className="container w-75 m-auto mb-5">
          <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
              <div className="row gy-4">
                <div className=" col-md-6 col-sm-12">
                  <Link to="/contestDetail"><ContestItem title="Contest 1" src={web2} className="fa fa-cup" li1a="3 Months Membership" li1b="Cash Price Rs. 1,00,000" li1c="Mentorship " li1d="Series A Fundraising" /></Link>
                </div>
                <div className="col-md-6 col-sm-12">
                  <Link to="/contestDetail"><ContestItem title="Contest 1" src={web2} className="fa fa-cup" li1a="3 Months Membership" li1b="Cash Price Rs. 1,00,000" li1c="Mentorship " li1d="Series A Fundraising" /></Link>
                </div>
              </div>
              <div className="row my-4">
                <div className=" col-md-6 col-sm-12">
                  <Link to="/contestDetail"><ContestItem title="Contest 1" src={web2} className="fa fa-cup" li1a="3 Months Membership" li1b="Cash Price Rs. 1,00,000" li1c="Mentorship " li1d="Series A Fundraising" /></Link>
                </div>
                <div className="col-md-6 col-sm-12">
                  <Link to="/contestDetail"><ContestItem title="Contest 1" src={web2} className="fa fa-cup" li1a="3 Months Membership" li1b="Cash Price Rs. 1,00,000" li1c="Mentorship " li1d="Series A Fundraising" /></Link>
                </div>
              </div>
            </div>
            <div className="tab-pane fade gy-4" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
              <div className="row gy-4">
                <div className=" col-md-6 col-sm-12">
                  <Link to="/contestDetail"><ContestItem title="Contest 1" src={web3} className="fa fa-cup" li1a="3 Months Membership" li1b="Cash Price Rs. 1,00,000" li1c="Mentorship " li1d="Series A Fundraising" /></Link>
                </div>
                <div className="col-md-6 col-sm-12">
                  <Link to="/contestDetail"><ContestItem title="Contest 1" src={web3} className="fa fa-cup" li1a="3 Months Membership" li1b="Cash Price Rs. 1,00,000" li1c="Mentorship " li1d="Series A Fundraising" /></Link>
                </div>
              </div>
              <div className="row my-4">
                <div className=" col-md-6 col-sm-12">
                  <Link to="/contestDetail"><ContestItem title="Contest 1" src={web3} className="fa fa-cup" li1a="3 Months Membership" li1b="Cash Price Rs. 1,00,000" li1c="Mentorship " li1d="Series A Fundraising" /></Link>
                </div>
                <div className="col-md-6 col-sm-12">
                  <Link to="/contestDetail"><ContestItem title="Contest 1" src={web3} className="fa fa-cup" li1a="3 Months Membership" li1b="Cash Price Rs. 1,00,000" li1c="Mentorship " li1d="Series A Fundraising" /></Link>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>

  )
}
